import { reactive, onMounted, provide } from "vue"

import BzbsCategory from "@/core/Campaign/service/BzbsCategory"
import { CategoryConfigBuilder } from "@/core/Campaign/config/CategoryConfigModel"
import Locale from "@/helper/locale/Locale"

export default function useCategoryComposable(firstDefault = true, configStr = "", subCategoryMode = false) {

    const states = reactive({
        /**@type {Array.<import("@/core/Campaign/model/CategoryModel").default>} */
        categoryList: [],
        current: null,
        builder: new CategoryConfigBuilder()
    })

    // set default
    states.builder.setLocale(Locale.getLocaleCode())
    states.builder.setConfig(configStr)

    const apiGetCategory = () => {
        // do nothing
        return new Promise((resolve, reject) => {
            BzbsCategory.apiGetCategory(states.builder.create().getParams()).subscribe({
                next: (data) => {

                    if(!subCategoryMode){
                        // root category mode
                        states.categoryList = data
                    }else{
                        // sub category mode
                        if(data.length == 1){
                            // set sub cats
                            states.categoryList = data[0].subcats
                        }else{
                            states.categoryList = data // fallback to root category mode
                        }
                    }
                    resolve(data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    provide("categoryStates", states)

    onMounted(() => {
        apiGetCategory().then((cats) => {
            if (firstDefault && cats.length > 0) {
                states.current = states.categoryList[0].id
            }
        })
    })

    return {
        states,
        apiGetCategory,
    }
}
